<template>
    <PageLoading v-if="isLoading" />
    <div
        v-else
        class="main-wrap"
    >
        <h1>{{ $t('certificates.validate_title') }}</h1>
        <q-btn
            class="q-my-lg btn-custom"
            size="32px"
            color="secondary"
            flat
            @click="cameraShow = true"
        >
            <q-icon
                name="qr_code"
                class="q-mr-md"
            ></q-icon>
            {{$t('profile.verify_certificate')}}
        </q-btn>
        <div
            class="q-px-md"
            style="max-width:480px"
        >
            <qrcode-stream
                v-if="cameraShow"
                @decode="onDecode"
            ></qrcode-stream>
        </div>
    </div>
</template>

<script>
import PageLoading from '@/components/PageLoading'
import { QrcodeStream } from 'vue-qrcode-reader'

const loadingKeys = {
    fetchingCertificate: 'fetching-certificate',
}

export default {
    name: 'ValidateCertificate',

    components: {
        PageLoading,
        QrcodeStream
    },

    data() {
        return {
            cameraShow: false,
            certificate: [],
        }
    },

    computed: {
        isLoading() {
            return this.isfetchingCertificate
        },

        isfetchingCertificate() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingCertificate
            ).length
        },
    },

    methods: {
        onDecode(decodedString) {
            this.loadingAdd(loadingKeys.fetchingCertificate)

            this.cameraShow = false
            window.location.replace('http://' + decodedString)

            this.loadingRemove(loadingKeys.fetchingCertificate)
        }
    }
}
</script>